import { TextField as FluentUITextField, ITextFieldProps, useTheme } from "@fluentui/react";
import React, { useEffect, useRef, useState } from "react";


const TextField: React.FunctionComponent<ITextFieldProps> = (props) => {
    const { onChange, value, defaultValue, readOnly, ...rest } = props;
    const refTextField = useRef<any>(null);

    const [key, setKey] = useState(0);

    const theme = useTheme();

    useEffect(() => {
        setKey(t => t + 1);
    }, [value]);

    // if (props.disabled)
    //     return <Stack styles={{ root: { minWidth: '176px', maxWidth: '100%' } }}>
    //         {props.label &&
    //             <Label styles={textProp.label}>
    //                 {props.label}
    //             </Label>
    //         }
    //         <Text styles={textProp.textStyles}>
    //             {props.value ?? "-"}
    //         </Text>
    //     </Stack>;


    return <>
        {/* {readOnly &&
            <div style={{ position: 'relative', width: '0', height: '0' }}>
                <Text variant="xSmall" style={{ left: '-15px', position: 'absolute', top: '8px' }}>
                    🔒
                </Text>
            </div>
        } */}
        <FluentUITextField
            {...rest}
            key={key}
            styles={{
                field: {
                    ...(props.disabled && { backgroundColor: theme.semanticColors.listBackground, cursor: 'not-allowed', color: theme.semanticColors.bodyText }),
                },
                prefix: {
                    ...(props.disabled && { backgroundColor: theme.semanticColors.bodyBackground, cursor: 'not-allowed', color: theme.semanticColors.bodyText }),
                },
                subComponentStyles: {
                    label: {
                        root: {
                            ...(props.disabled && { backgroundColor: theme.semanticColors.bodyBackground, color: theme.semanticColors.bodyText }),

                        }
                    }
                }
            }}
            readOnly={readOnly}
            componentRef={refTextField}
            onBlur={(event) => {
                if (onChange) {
                    const uncontrolledValue = refTextField?.current?.state?.uncontrolledValue ?? '';
                    onChange(event, uncontrolledValue);
                }
            }}
            defaultValue={value}
        />
    </>
}

export default TextField;